<template>
    <svg id="varukorg-thin_svg__Lager_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 11.9 11.9"
         xml:space="preserve" width="15" height="15" fill="white" alt="Lägg till"
         style="margin-top: -2px;"
    >
        <path class="varukorg-thin_svg__st0" d="M.9 3.4l-.7 8.3h11.5L11 3.4z"></path>
        <path class="varukorg-thin_svg__st0"
              d="M6 .2C3.8.2 3.5 2.1 3.5 2.7v.7M6 .2c2.2 0 2.5 1.9 2.5 2.5v.7"></path></svg>
</template>
<style scoped>
.varukorg-thin_svg__st0 {
    fill: none;
    stroke: currentColor;
    stroke-width: .5;
    stroke-miterlimit: 10
}</style>
